import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';
import SEO from './SEO';

const AboutUs = () => {
  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "About Techie Interiors",
      "description": "Learn about Techie Interiors - a leading interior design company in Nairobi Kenya specializing in modern, customized solutions for residential and commercial spaces.",
      "url": "https://techieinteriors.co.ke/about-us",
      "mainEntity": {
        "@type": "LocalBusiness",
        "name": "Techie Interiors",
        "image": "https://techieinteriors.co.ke/techLogo.jpeg",
        "telephone": "+254748600208",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Nairobi",
          "addressCountry": "KE"
        },
        "description": "Interior design and furniture company in Nairobi Kenya offering gypsum ceilings, wardrobes, kitchen cabinets, TV wall units, soundproofing, and more."
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Why choose Techie Interiors?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Techie Interiors is a trusted interior design company in Nairobi, Kenya, known for delivering modern, customized, and affordable interior solutions. We combine creativity, technical expertise, and high-quality materials to transform residential and commercial spaces into functional and visually appealing environments."
          }
        },
        {
          "@type": "Question",
          "name": "What makes Techie Interiors different from other interior design companies in Nairobi?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Techie Interiors stands out due to its comprehensive service offering, expert team, and customer-focused approach. Unlike many companies, we handle everything from concept design, 3D visualization, and product sourcing to installation and project completion, ensuring a seamless experience for our clients."
          }
        },
        {
          "@type": "Question",
          "name": "Does Techie Interiors offer both interior design services and interior products?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Techie Interiors provides both interior design services and interior products in Kenya. We design, supply, and install items such as gypsum ceilings, TV wall units, wardrobes, kitchen cabinets, and other home décor solutions, making us a one-stop solution for all interior needs."
          }
        },
        {
          "@type": "Question",
          "name": "Are your interior design services customizable?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Absolutely. We specialize in customized interior design solutions tailored to your style, space, and budget. Whether you prefer modern, minimalist, or luxury designs, we create personalized solutions that reflect your vision and lifestyle."
          }
        },
        {
          "@type": "Question",
          "name": "How affordable are your interior design services in Nairobi?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Techie Interiors offers affordable interior design services in Nairobi without compromising on quality. Our pricing is competitive and flexible, ensuring clients receive value for money whether they need full home design, renovation, or specific installations."
          }
        },
        {
          "@type": "Question",
          "name": "What services does Techie Interiors provide?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We offer a wide range of interior design and installation services in Kenya, including: Gypsum ceiling design and installation, Electrical and lighting solutions, Soundproofing and insulation, TV wall units and wall paneling, Kitchen and wardrobe fittings, 3D interior design renderings, and Ceiling and electrical technical drawings."
          }
        },
        {
          "@type": "Question",
          "name": "Do you handle both residential and commercial projects?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Techie Interiors works on both residential and commercial interior design projects. We design and transform homes, offices, hotels, retail shops, and other commercial spaces across Nairobi and Kenya."
          }
        },
        {
          "@type": "Question",
          "name": "Do you provide 3D design before starting a project?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, we offer high-quality 3D renderings and visualizations. This allows clients to see a realistic preview of their space before construction begins, helping them make informed decisions and adjustments."
          }
        },
        {
          "@type": "Question",
          "name": "How experienced is your team?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Our team consists of skilled interior designers, engineers, and technicians with extensive experience in interior design and project execution. We ensure every project meets high standards of quality, safety, and professionalism."
          }
        },
        {
          "@type": "Question",
          "name": "Do you offer project management services?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, we provide full project management services. From planning and design to execution and final finishing, we oversee every stage to ensure timely delivery and quality results."
          }
        },
        {
          "@type": "Question",
          "name": "Can Techie Interiors handle renovations and remodeling?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, we specialize in interior renovations and remodeling in Kenya. Whether upgrading a single room or redesigning an entire space, we deliver modern and functional solutions."
          }
        },
        {
          "@type": "Question",
          "name": "Where is Techie Interiors located?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Techie Interiors is based in Nairobi, Kenya, and serves clients across the country, offering both on-site and remote consultation services."
          }
        }
      ]
    }
  ];

  return (
    <div className="about-container">
      {/* SEO Component */}
      <SEO
        title="About Techie Interiors | Leading Interior Design Company Kenya"
        description="Learn about Techie Interiors - Nairobi's trusted interior design company. We specialize in gypsum ceilings, custom wardrobes, kitchen cabinets, TV wall units, and complete interior solutions for homes and businesses in Kenya."
        image="/techLogo.jpeg"
        url="https://techieinteriors.co.ke/about-us"
        structuredData={structuredData}
      />
      <div className="about-hero">
        <div className="hero-content">
          <h1>Techie Interiors</h1>
          <p className='hero-subtitle'>Transforming Spaces, Enhancing Lives</p>
        </div>
      </div>

      <div className="about-content">
        <section className="about-section">
          <div className="container">
            <h2>Who We Are</h2>
            <p>
            Techie Interiors is a Nairobi-based company specializing in <Link to="/gypsum-ceiling"> gypsum ceilings, </Link> <Link to="/kitchen-wardrobe-fitting">
             kitchens, </Link> <Link to="/wain-scouting"> wardrobes, </Link> <Link to="/wain-scouting"> wall panels, </Link> and interior finishes.
            We provide both installation services and supply of quality materials, making us a one-stop solution for your project.
            </p>
          </div>
        </section>

        <section className="about-section alternate-bg">
          <div className="container">
            <h2>Our Expertise</h2>
            <p>
              Our expertise includes gypsum ceiling design, custom interior products, kitchen and wardrobe 
              fittings, wall units, lighting solutions, and home décor products. Whether you are 
              looking for modern interiors in Nairobi, interior décor accessories, or complete 
              interior design services in Kenya, Techie Interiors delivers tailored solutions to 
              meet your needs.
            </p>
          </div>
        </section>

        <section className="about-section">
          <div className="container">
            <h2>Our Approach</h2>
            <p>
              We work closely with architects, contractors, and homeowners to transform spaces into 
              elegant, functional environments. From concept development and 3D visualization to 
              installation and finishing, we ensure every project is executed with precision and 
              professionalism.
            </p>
          </div>
        </section>

        <section className="about-section alternate-bg">
          <div className="container">
            <h2>Our Commitment</h2>
            <p>
              Techie Interiors is committed to providing affordable interior products in Kenya while 
              maintaining high standards of quality, innovation, and customer satisfaction.
            </p>
          </div>
        </section>

        <section className="about-section faq-section">
          <div className="container">
            <h2>Frequently Asked Questions About Techie Interiors</h2>
            
            <div className="faq-item">
              <h3>Why choose Techie Interiors?</h3>
              <p>
                Techie Interiors is a trusted interior design company in Nairobi, Kenya, known for delivering modern, customized, and affordable interior solutions. We combine creativity, technical expertise, and high-quality materials to transform residential and commercial spaces into functional and visually appealing environments.
              </p>
            </div>

            <div className="faq-item">
              <h3>What makes Techie Interiors different from other interior design companies in Nairobi?</h3>
              <p>
                Techie Interiors stands out due to its comprehensive service offering, expert team, and customer-focused approach. Unlike many companies, we handle everything from concept design, 3D visualization, and product sourcing to installation and project completion, ensuring a seamless experience for our clients.
              </p>
            </div>

            <div className="faq-item">
              <h3>Does Techie Interiors offer both interior design services and interior products?</h3>
              <p>
                Yes, Techie Interiors provides both interior design services and interior products in Kenya. We design, supply, and install items such as gypsum ceilings, TV wall units, wardrobes, kitchen cabinets, and other home décor solutions, making us a one-stop solution for all interior needs.
              </p>
            </div>

            <div className="faq-item">
              <h3>Are your interior design services customizable?</h3>
              <p>
                Absolutely. We specialize in customized interior design solutions tailored to your style, space, and budget. Whether you prefer modern, minimalist, or luxury designs, we create personalized solutions that reflect your vision and lifestyle.
              </p>
            </div>

            <div className="faq-item">
              <h3>How affordable are your interior design services in Nairobi?</h3>
              <p>
                Techie Interiors offers affordable interior design services in Nairobi without compromising on quality. Our pricing is competitive and flexible, ensuring clients receive value for money whether they need full home design, renovation, or specific installations.
              </p>
            </div>

            <div className="faq-item">
              <h3>What services does Techie Interiors provide?</h3>
              <p>We offer a wide range of interior design and installation services in Kenya, including:</p>
              <ul className="faq-list">
                <li>Gypsum ceiling design and installation</li>
                <li>Electrical and lighting solutions</li>
                <li>Soundproofing and insulation</li>
                <li>TV wall units and wall paneling</li>
                <li>Kitchen and wardrobe fittings</li>
                <li>3D interior design renderings</li>
                <li>Ceiling and electrical technical drawings</li>
              </ul>
            </div>

            <div className="faq-item">
              <h3>Do you handle both residential and commercial projects?</h3>
              <p>
                Yes, Techie Interiors works on both residential and commercial interior design projects. We design and transform homes, offices, hotels, retail shops, and other commercial spaces across Nairobi and Kenya.
              </p>
            </div>

            <div className="faq-item">
              <h3>Do you provide 3D design before starting a project?</h3>
              <p>
                Yes, we offer high-quality 3D renderings and visualizations. This allows clients to see a realistic preview of their space before construction begins, helping them make informed decisions and adjustments.
              </p>
            </div>

            <div className="faq-item">
              <h3>How experienced is your team?</h3>
              <p>
                Our team consists of skilled interior designers, engineers, and technicians with extensive experience in interior design and project execution. We ensure every project meets high standards of quality, safety, and professionalism.
              </p>
            </div>

            <div className="faq-item">
              <h3>Do you offer project management services?</h3>
              <p>
                Yes, we provide full project management services. From planning and design to execution and final finishing, we oversee every stage to ensure timely delivery and quality results.
              </p>
            </div>

            <div className="faq-item">
              <h3>Can Techie Interiors handle renovations and remodeling?</h3>
              <p>
                Yes, we specialize in interior renovations and remodeling in Kenya. Whether upgrading a single room or redesigning an entire space, we deliver modern and functional solutions.
              </p>
            </div>

            <div className="faq-item">
              <h3>Do you offer installation services for interior products?</h3>
              <p>
                Yes, we provide complete installation services for all our interior products, including gypsum ceilings, wardrobes, kitchen cabinets, CCTV systems, and wall units.
              </p>
            </div>

            <div className="faq-item">
              <h3>Where is Techie Interiors located?</h3>
              <p>
                Techie Interiors is based in Nairobi, Kenya, and serves clients across the country, offering both on-site and remote consultation services.
              </p>
            </div>

            <div className="faq-item">
              <h3>How can I get started with Techie Interiors?</h3>
              <p>
                Getting started is simple. Contact Techie Interiors for a consultation, and our team will assess your needs, provide recommendations, and guide you through the design and implementation process.
              </p>
            </div>

            <div className="faq-item">
              <h3>Do you work with specific budgets?</h3>
              <p>
                Yes, we tailor our services to fit different budgets. Whether you are looking for affordable interior solutions or premium designs, we provide options that align with your financial plan.
              </p>
            </div>

            <div className="faq-item">
              <h3>How long does an interior design project take?</h3>
              <p>
                Project timelines vary depending on the size and complexity of the work. Small projects may take a few days, while larger residential or commercial projects may take several weeks. We always provide a clear timeline before starting.
              </p>
            </div>

            <div className="faq-item">
              <h3>Is Techie Interiors suitable for small spaces?</h3>
              <p>
                Yes, we specialize in optimizing small spaces using smart interior design techniques, modern and affordable services, and efficient layouts to maximize functionality and style.
              </p>
            </div>

            <div className="faq-item">
              <h3>Do you provide after-service support?</h3>
              <p>
                Yes, we offer maintenance, support, and follow-up services to ensure your installations and designs remain in excellent condition over time.
              </p>
            </div>
          </div>
        </section>

        <section className="about-cta">
          <div className="container">
            <h2>Transform Your Space Today</h2>
            <p>Ready to bring your vision to life? Contact us for a consultation.</p>
            <Link to="/contact-us" className="cta-button">Get in Touch</Link>
            <p>
              Explore our <Link to="/services">full interior services</Link>, see our{' '}
              <Link to="/project">recent projects</Link>, and check our{' '}
              <Link to="/interior-design-nairobi">Nairobi interior solutions</Link>.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutUs;
